import React from "react";
import Types from "prop-types";
import LanguageSelector from "../../LanguageSelector";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import Analytika from "../../../analytika";
import { GalileoContext } from "../../../galileo";
import ButtonEnhanced from "../../common/enhanced/ButtonEnhanced";
import eventAnalytics from "../../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../../utils/constants";
import TryAnotherWayImg from "../../../images/try-another-way.svg";
import { loadSheild } from "../../../sheild";
import PasswordField from "../../common/PasswordField";

export class PasswordLoginForm extends React.Component {
  constructor(props) {
    super(props);

    loadSheild();
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.PASSWORD);
    eventAnalytics.publishViewPage(ANALYTIKA_EVENTS.PAGE.PASSWORD);
    Analytika.fireEvent("Idtn_Web_PasswordLogin_View", {
      phonenumber: props.fullPhoneNumber,
    });
    this.onPasswordChange = props.onPasswordChange;
    this.onTryAnotherClickHandler = props.onTryAnotherClickHandler;
    this.isTryAnotherWayVisible = props.isTryAnotherWayVisible;
    this.onSubmit = props.onSubmit;
    this.signupEndpoint = props.signupEndpoint;
    this.recoveryEndpoint = props.recoveryEndpoint;

    this.createAccount = this.createAccount.bind(this);
  }

  static contextType = GalileoContext;

  forgotPassword() {
    eventAnalytics.publishV2(
      ANALYTIKA_EVENTS.IDNW_TAP_OPTION,
      {
        option_name: "forgot_password",
      }
    );
    Analytika.fireEvent("Idtn_Web_PasswordLogin_Forget_Clicked", {
      phonenumber: this.props.fullPhoneNumber,
    });
    eventAnalytics.flush().then(() => {
      window.location.href = this.recoveryEndpoint;
    });
  }

  createAccount() {
    eventAnalytics.publishV2(
      ANALYTIKA_EVENTS.IDNW_TAP_OPTION,
      {
        option_name: "create_account",
      }
    );
    Analytika.fireEvent("Idtn_Web_PasswordLogin_Signup_Clicked", {
      phonenumber: this.props.fullPhoneNumber,
    });
    eventAnalytics.flush().then(() => {
      window.location.href = this.signupEndpoint;
    });
  }

  render() {
    const { isEnhancedFormEnabled } = this.context;
    return isEnhancedFormEnabled ? this.renderEnhanced() : this.renderClassic();
  }

  renderClassic() {
    const { t, error, submitting } = this.props;

    return (
      <form data-request-type="password_submit" onSubmit={this.onSubmit}>
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        <div className="help-lang-container">
          <LanguageSelector />
        </div>
        <h1>{t("login:password_title")}</h1>

        {error && <div className="invalid show">{error}</div>}

        <PasswordField
          id="password"
          name="password"
          label={t("signup:password")}
          onChange={this.onPasswordChange}
          onFocus={() =>
            Analytika.fireEvent("Idtn_Web_PasswordLogin_Password_Focus", {
              phonenumber: this.props.fullPhoneNumber,
            })
          }
          variant="classic"
        />

        {this.isTryAnotherWayVisible && (
          <div
            className="btn-try-another-way"
            name="btn-try-another-way"
            onClick={this.onTryAnotherClickHandler}
          >
            <img src={TryAnotherWayImg} alt="TryAnotherWayImg" width="20px" />
            {t("login:try-another-way")}
          </div>
        )}
        {!this.isTryAnotherWayVisible && (
          <>
            <div className="info center">
              <button
                type="button"
                className="button-looks-like-link"
                onClick={this.forgotPassword.bind(this)}
              >
                {t("login:forgot_password")}
              </button>
            </div>
            <div className="row">
              <p className="footer-link col-xs-12">
                {t("login:new_to_careem")}
                <button
                  type="button"
                  className="button-looks-like-link"
                  onClick={this.createAccount.bind(this)}
                >
                  {t("login:create_account")}
                </button>
              </p>
            </div>
          </>
        )}
        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="verify-recover-btn"
          disabled={submitting}
        />
        {this.isTryAnotherWayVisible && (
          <input
            className="btn-careem-tertiary"
            type="button"
            value={t("login:create_account")}
            name="btn-create-account"
            onClick={this.createAccount}
          />
        )}

        <ReCaptcha />
      </form>
    );
  }

  renderEnhanced() {
    const { t, error, submitting } = this.props;

    return (
      <form
        data-submit-event="Idtn_Web_PasswordLogin_Submit"
        onSubmit={this.onSubmit}
      >
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        <h1 className="heading-h1-express center express-common">
          {t("login:confirmation_name_title")}
        </h1>

        <PasswordField
          id="password"
          name="password"
          label={t("signup:password")}
          onChange={this.onPasswordChange}
          onFocus={() =>
            Analytika.fireEvent("Idtn_Web_PasswordLogin_Password_Focus", {
              phonenumber: this.props.fullPhoneNumber,
            })
          }
          variant="enhanced"
          hasError={!!error}
        />
        {error && <div className="invalid show">{error}</div>}
        <ButtonEnhanced
          className="express-form-distant-item"
          name="verify-recover-btn"
          disabled={submitting}
          type="submit"
          fullWidth
          btnType="primary"
        >
          {submitting ? t("common:please_wait") : t("login:login-button")}
        </ButtonEnhanced>

        <div className="row express-form-distant-item center">
          <p className="express-text-secondary express-common">
            {t("login:forgot_password")}{" "}
            <button
              className="button-like-link express-link-action"
              onClick={this.forgotPassword.bind(this)}
            >
              {t("login:reset_password")}
            </button>
          </p>
        </div>

        <ReCaptcha />
      </form>
    );
  }
}

PasswordLoginForm.propTypes = {
  t: Types.func.isRequired,
  onPasswordChange: Types.func.isRequired,
  onTryAnotherClickHandler: Types.func.isRequired,
  isTryAnotherWayVisible: Types.bool.isRequired,
  onSubmit: Types.func.isRequired,
  signupEndpoint: Types.string,
  recoveryEndpoint: Types.string,
  fullPhoneNumber: Types.string,
  error: Types.string,
  submitting: Types.bool,
};
export default withTranslation()(PasswordLoginForm);
